module.exports = __webpack_public_path__ + "img/sk.a5c6a8fc.svg";